import "./index.scss";
import { AiOutlineClose, AiOutlineCheck } from "react-icons/ai";
import { Modal } from "../Modal";
import { Button, FlexRow } from "src/style";
import { useContext } from "react";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import { useNavigate } from "react-router-dom";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";

export const LogoutModal = () => {
  const navigate = useNavigate();
  const { visibility, setModal } = useContext(VisibilityContext);
  const { logout } = useContext(AppInfoContext);

  const handleLogoutModal = () =>
    setModal({ key: "showLogout", value: !visibility.showLogout });

  const handleLogout = () => {
    navigate("/");
    logout();
    handleLogoutModal();
  };

  return (
    <Modal
      isOnMenu
      open={visibility.showLogout}
      cancel={handleLogoutModal}
      className="logout-modal"
    >
      <div className="confirmation">Are you sure you want to Logout?</div>
      <FlexRow justifyContent="space-between" className="btn-container">
        <Button
          hoverColor="#A77B37"
          onClick={handleLogoutModal}
          className="logout-btn cancel"
        >
          <AiOutlineClose size={17} />
          Cancel
        </Button>
        <Button
          hoverBgColor="#fff"
          hoverColor="#A77B37"
          borderColor="#A77B37"
          onClick={handleLogout}
          className="logout-btn confirm"
        >
          <AiOutlineCheck size={17} />
          Confirm
        </Button>
      </FlexRow>
    </Modal>
  );
};
